import types from 'redux/types';

const releaseDidNow = (data) => {
  return {
    ...data,
    type: types.REQUEST_RELEASE_DID_NOW,
  };
};

const saveDid = (data) => {
  return {
    ...data,
    type: types.REQUEST_SAVE_DID,
  };
};

const getPurchaseProcess = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_PURCHASE_PROCESS,
  };
};

const clearSearchInput = () => {
  return {
    type: types.CLEAR_DID_KEYWORDS,
  };
};

const searchDid = (data) => {
  return {
    ...data,
    type: types.REQUEST_SEARCH_DID,
  };
};

const getListDidGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_LIST_DIDS,
  };
};

const getDidGroupDetail = (data) => {
  return {
    ...data,
    type: types.REQUEST_DID_DETAIL,
  };
};

const createDid = (data) => {
  return {
    ...data,
    type: types.REQUEST_ADD_DID_GROUP,
  };
};

const deleteDidGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_DID,
  };
};

const getAvailablePhoneNumber = (data) => {
  return {
    ...data,
    type: types.REQUEST_BULK_PURCHASE,
  };
};

const moveDid = (data) => {
  return {
    ...data,
    type: types.REQUEST_MOVE_DID,
  };
};

const moveDidSelected = (data) => {
  return {
    ...data,
    type: types.REQUEST_MOVE_DID_SELECTED,
  };
};

const checkStatePurchasingAllGroup = () => {
  return {
    type: types.REQUEST_CHECK_PURCHASE_ALL_GROUP,
  };
};

const clearDidDetail = () => {
  return {
    type: types.REQUEST_CLEAR_DID_DETAIL,
  };
};

const deleteSingleDidGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_SINGLE_DID,
  };
};

const loadMoreDidGroups = (data) => {
  return {
    ...data,
    type: types.REQUEST_LOAD_MORE_DIDS_GROUP,
  };
};

const getTotalDidInAccount = (data) => {
  return {
    type: types.REQUEST_GET_TOTAL_DID_IN_ACCOUNT,
    ...data,
  };
};

const releaseDidByClickRate = (data) => {
  return {
    type: types.REQUEST_RELEASE_DID_BY_CLICK_RATE,
    ...data,
  };
};

export default {
  releaseDidByClickRate,
  getTotalDidInAccount,
  loadMoreDidGroups,
  releaseDidNow,
  saveDid,
  moveDidSelected,
  deleteSingleDidGroup,
  checkStatePurchasingAllGroup,
  clearSearchInput,
  searchDid,
  clearDidDetail,
  moveDid,
  createDid,
  getDidGroupDetail,
  deleteDidGroup,
  getAvailablePhoneNumber,
  getListDidGroup,
  getPurchaseProcess,
};
